module.exports = __webpack_public_path__ + "img/logo.521ad94c.png";